import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "card-data" }
const _hoisted_3 = { class: "main-page-feature" }
const _hoisted_4 = { class: "feature-title" }
const _hoisted_5 = { class: "feature-sub-title" }
const _hoisted_6 = {
  key: 0,
  class: "feature-sub-title text-black mt-1"
}
const _hoisted_7 = { class: "main-page-content" }
const _hoisted_8 = { class: "main-page-text" }
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card top-right-color-triangle",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "top-triangle" }, [
          _createElementVNode("div", { class: "top-right-color-triangle" }),
          _createElementVNode("div", { class: "top-right-grey-triangle" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"30px","margin-top":"5rem","text-align":"center","font-weight":"500"} }, " Private and Confidential ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.data.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.subTitle), 1),
            (!_ctx.fetchingChartData && this.filterRanges && _ctx.getNavDateVal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " As on " + _toDisplayString(_ctx.getNavDateVal), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main-page-content-title" }, "Introduction and Context", -1)),
            _createElementVNode("div", _hoisted_8, " This report has been prepared for " + _toDisplayString(_ctx.data.title) + ". The data received from " + _toDisplayString(_ctx.data.title) + " has assisted AgeWage to caliberate returns against a benchmark that can be used to analyse all individual DC pension pots and satisfy the Work and Pensions Select Committee's recent call for a common definition of value for money. ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}